module.exports = __webpack_public_path__ + "img/centrum-cocktails-closeup.2186f273.jpg";